import React, { useEffect } from "react";
import { Wait } from "../../models/testSteps/wait";
import { TextField, Grid, Typography } from "@mui/material";

interface Props {
  data: Wait;
  onChange: (updated: Wait) => void;
  setIsValid: (valid: boolean) => void;
}

const EditWaitForm: React.FC<Props> = ({ data, onChange, setIsValid }) => {
  useEffect(() => {
    setIsValid(data.name.trim() !== "" && data?.wait_ms > 0);
  }, [data, setIsValid]);

  return (
    <>
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          value={data.name}
          fullWidth
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          label="Zeit (ms)"
          type="number"
          fullWidth
          inputProps={{ min: 1 }}
          value={data.wait_ms}
          onChange={(e) =>
            onChange({ ...data, wait_ms: parseInt(e.target.value) || 0 })
          }
        />
      </Grid>
    </Grid>
    </>
  );
};

export default EditWaitForm;
